<div class="pl-pane__container--horizontal">
<header class="pl-page-header pl-pane--shrink">
  <h1 class="pl-heading--xlarge">
    {{ 'REGISTRATIONS.registrations' | translate }}
  </h1>
</header>

<se-fe-tabs
  [seFeDataTabPanel]="tabPanel"
  [seFeDataTabs]="tabs"
  seFeDataAriaLabel="Registration views"
  (click)="handleTabsClick($event)"></se-fe-tabs>

<se-fe-tab-panel #tabPanel>
  <router-outlet></router-outlet>
</se-fe-tab-panel>
</div>
